// chatGpt写的，比我强
import { useState } from 'react';
import { useDeepCompareEffect } from '@fuxi/eevee-hooks';

type VideoPreloadHookProps = {
  urls: string[];
};

const useVideoPreload = ({ urls }: VideoPreloadHookProps): boolean => {
  const [isLoaded, setIsLoaded] = useState(false);

  useDeepCompareEffect(() => {
    const videos = urls.map(url => {
      const video = document.createElement('video');
      video.src = url;
      video.preload = 'metadata';
      video.load();
      return video;
    });

    // 检查视频是否加载完成
    const checkLoaded = () => {
      const allLoaded = videos.every(video => video.readyState >= 2);
      if (allLoaded) {
        setIsLoaded(true);
      } else {
        window.requestAnimationFrame(checkLoaded);
      }
    };

    checkLoaded();

    // 卸载时释放资源
    return () => {
      videos.forEach(video => URL.revokeObjectURL(video.src));
    };
  }, [urls]);

  return isLoaded;
};

export default useVideoPreload;
